<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="card my-profile-form margin-top-15px top-link" *ngIf="ShowList">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="row">
        <div class="col-md-7">
          Articles 
        </div>
        <div class="col-md-5 padding-right-0px">
          <div class="row">
            <div class="offset-md-3 col-md-2 padding-right-0px text-align-center">
              <a (click)="OpenBill()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Article" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
            </div>            
            <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
              <!--<form novalidate="" #f="ngForm" class="display-inherit">
                <div class="clear-form">
                  <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                  <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                </div>
                <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
              </form>-->
              <search-list [title]="searchTitle" [hideTitle]="1"></search-list>

            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>
                    <th class="min-width-24px">
                      #
                    </th>
                    <th class="">
                      Category
                    </th>
                    <th class="">
                      Title
                    </th>
                    <th class="">
                      Date
                    </th>
                    <th class="">
                      Published In
                    </th>
                    <th class="">
                      Presented At
                    </th>
                    <th class="">Posted By</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr *ngFor="let l of CurrentArticleListController; let RowIndex = index ">
                    <td class="td-padding-tb">
                      {{RowIndex+1}}
                    </td>
                    <td class="td-padding-tb">{{l.DocumentCategory}}</td>

                    <td class=" td-padding-tb">{{l.Name}}</td>

                    <td class=" td-padding-tb">{{l.CreatedAt | date:'MMM-dd-yyyy'}}</td>


                    <td class="td-padding-tb">{{l.PublishedIn}}</td>
                    <td class="td-padding-tb ">{{l.PresentedIn}}</td>
                    <td class=" td-padding-tb ">{{l.PostedBy}}</td>

                    <td class="td-padding-tb">{{l.RecordStatus}}</td>
                    <td class="td-padding-tb">
                      <button type="submit" class="button-service-save padding-right-15px font-size-16px color-secondary nav-link-hand margin-left-3px"><i class="fas fa-pencil-alt"></i></button>
                      <a class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                    </td>






                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


